var _effectorFileName = "/src/shared/api/payment/api.ts";
import { withFactory as _withFactory } from "effector";
import { Service } from '@/pages/api/services/types';
import { Teacher } from '@/pages/api/teachers/types';
import { createMutation, createQuery } from '@farfetched/core';
import { createEffect, createStore } from 'effector';
import { PaymentData } from '@/page-content/payment/components/payment-form/types';
import { httpClient } from '../api';
import { PaymentResponse, PromocodeData, PromocodeResponse, ServicesResponse, TeachersResponse } from './types';
const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:3000' : process.env.NEXT_PUBLIC_APP_URL;

// GET TEACHERS

export const $teachersList = createStore<Array<Teacher>>([], {
  loc: {
    file: _effectorFileName,
    line: 15,
    column: 29
  },
  name: "$teachersList",
  sid: "-xz6823"
});
export const getTeachersFx = createEffect(async () => {
  const teachersResponse = await httpClient<TeachersResponse>(`${URL}/api/teachers`);
  return teachersResponse;
}, {
  loc: {
    file: _effectorFileName,
    line: 17,
    column: 29
  },
  name: "getTeachersFx",
  sid: "5q6uyh"
});
export const getTeachersQuery = _withFactory({
  sid: "-f6hsya",
  fn: () => createQuery({
    handler: getTeachersFx
  }),
  name: "getTeachersQuery",
  method: "createQuery",
  loc: {
    file: _effectorFileName,
    line: 23,
    column: 32
  }
});

// GET SERVICES

export const $servicesList = createStore<Array<Service>>([], {
  loc: {
    file: _effectorFileName,
    line: 29,
    column: 29
  },
  name: "$servicesList",
  sid: "y1aphb"
});
export const getServicesFx = createEffect(async () => {
  const servicesResponse = await httpClient<ServicesResponse>(`${URL}/api/services`);
  return servicesResponse;
}, {
  loc: {
    file: _effectorFileName,
    line: 31,
    column: 29
  },
  name: "getServicesFx",
  sid: "-meeysy"
});
export const getServicesQuery = _withFactory({
  sid: "xeapa6",
  fn: () => createQuery({
    handler: getServicesFx
  }),
  name: "getServicesQuery",
  method: "createQuery",
  loc: {
    file: _effectorFileName,
    line: 37,
    column: 32
  }
});

// POST PAYMENT DATA

export const postPaymentDataFx = createEffect(async (paymentData: PaymentData) => {
  const teachersResponse = await httpClient<PaymentResponse>(`${URL}/api/paycheck`, {
    method: 'POST',
    body: JSON.stringify(paymentData),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return teachersResponse;
}, {
  loc: {
    file: _effectorFileName,
    line: 43,
    column: 33
  },
  name: "postPaymentDataFx",
  sid: "dmpvrk"
});
export const postPaymentDataMutation = _withFactory({
  sid: "r6j8dc",
  fn: () => createMutation({
    handler: postPaymentDataFx
  }),
  name: "postPaymentDataMutation",
  method: "createMutation",
  loc: {
    file: _effectorFileName,
    line: 55,
    column: 39
  }
});

// POST PROMOCODE

export const postPromocodeDataFx = createEffect(async (promocode: PromocodeData) => {
  const promocodeResponse = await httpClient<PromocodeResponse>(`${URL}/api/promocode`, {
    method: 'POST',
    body: JSON.stringify(promocode),
    headers: {
      'Content-Type': 'application/json'
    }
  });
  return promocodeResponse;
}, {
  loc: {
    file: _effectorFileName,
    line: 61,
    column: 35
  },
  name: "postPromocodeDataFx",
  sid: "-q8vxq0"
});
export const postPromocodeDataMutation = _withFactory({
  sid: "gx32qr",
  fn: () => createMutation({
    handler: postPromocodeDataFx
  }),
  name: "postPromocodeDataMutation",
  method: "createMutation",
  loc: {
    file: _effectorFileName,
    line: 73,
    column: 41
  }
});